import type { MouseEvent } from 'react'

/**
 * 站內 <a> 點擊的平滑捲動偏移，對應 sticky `.topnav` 的實測高度
 * （desktop ~72 / mobile ~71px）＋小間距。這裡處理站內 JS 路徑；
 * 外部直貼 `/#id` 的原生捲動則由目標 section 的 scroll-margin-top 清開頁首。
 * 值必須 >= topnav 實測高度，否則 section 上緣會被壓在半透明 topnav 之下。
 */
export const ANCHOR_SCROLL_OFFSET_PX = 80

/**
 * 錨點平滑捲動（scrollTo top - ANCHOR_SCROLL_OFFSET_PX，不用 scrollIntoView）。
 * 掛在 href="#…" 的 <a> onClick 上；目標不存在時保留瀏覽器預設行為。
 */
export function smoothScrollToAnchor(event: MouseEvent<HTMLAnchorElement>) {
  const href = event.currentTarget.getAttribute('href')
  if (!href || !href.startsWith('#') || href.length < 2) return
  const target = document.querySelector(href)
  if (!target) return
  event.preventDefault()
  const top = target.getBoundingClientRect().top + window.scrollY - ANCHOR_SCROLL_OFFSET_PX
  window.scrollTo({ top, behavior: 'smooth' })
}
